<template>
    <a v-for="(tile, index) in tiles" :href="tile.url" class="search-result" :class="`search-result--${tile.collection.handle} ${projectClass}`">
        <div class="search-result__content">
            <div class="search-result__type">
                <template v-if="tile.publication_types">
                    {{ tile.publication_types.title }}
                </template>
                <template v-else>Project</template>
            </div>
            <h4 class="search-result__title">
                {{ tile.title }}
            </h4>

            <div class="search-result__caption">
                <template v-if="tile.project_phase">
                    <div class="search-result__phase">
                    in {{ tile.project_phase.label }}
                    </div>
                    
                    <div class="bullet">&#8226;</div>
                </template>

                <template v-if="tile.related_areas_of_investigation">
                    <div class="search-result__related-aoi">
                        related to 
                        <span v-for="related in tile.related_areas_of_investigation" class="search-result__aoi-title">
                            {{ related.title }}
                        </span>
                    </div>
                    <div class="bullet">&#8226;</div>
                </template>

                <template v-if="tile.related_programs">
                    
                    <div class="search-result__related-program">
                        in
                        <span v-for="related in tile.related_programs" class="search-result__program-title">
                            {{ related.title }}
                        </span>
                    </div>
                    <div class="bullet">&#8226;</div>
                </template>

                <template v-if="tile.method">
                    <div class="search-result__method">
                        <span v-for="(related) in tile.method" class="search-result__method-title">
                            {{ related.title }}
                        </span>
                    </div>
                </template>
            </div>

        </div>

        <div class="search-result__image">
          <div class="media media--filter--projects">
            <img class="media__obj media__obj--img media__obj--lazy" :src="images[index]" :alt="tile.title" />
          </div>
        </div>
      </a>
</template>

<script>

export default {
  name: 'ResultTile',
  props: ['tiles', 'images', 'collection'],
  computed: {
    projectClass() {
        if (this.$props.collection === 'projects') {
            return 'search-result--projects'
        }
    }
  }
}
</script>